export const BrandContainerIds = {
  pre: [265, 267],
  prod: [273, 275]
}

export const BrandCardParentIds = {
  pre: [267],
  prod: [275]
}
